/* eslint-disable */
import React, { Component } from 'react'
import { CheckBox } from 'react-native-elements'
//import { KeyboardAccessoryNavigation } from 'react-native-keyboard-accessory'
//import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { StatusBar, ScrollView, Text, /*KeyboardAvoidingView, */ TextInput, View, Platform, Dimensions, Animated, Keyboard, TouchableOpacity, TouchableWithoutFeedback, Easing } from 'react-native'
import { NavigationEvents, NavigationActions } from 'react-navigation';
import { connect } from 'react-redux'
import RoundedButton from "../Components/RoundedButton"
import InputCell from '../Components/InputCell'
import BadgeButton from '../Components/BadgeButton'
import ProfilePhotoCell from '../Components/ProfilePhotoCell'
import ProfilePhoto from '../Components/ProfilePhoto'
import Spacer from '../Components/Spacer'
import TextareaCell from '../Components/TextAreaCell'
import TermsCell from '../Components/TermsCell'
import AuthActions from '../Redux/AuthRedux'

import NavigationBar from "../Components/NavigationBar"
import { SvgBackButton } from '../Components/SvgComponent/';
import TextInputComponent from "../Components/TextInputComponent"
import { isIPhoneX } from '../Lib/utils';
import SlideButton from "../Components/SlideButton"
import { TERMURL } from '../Constant';
import { Fonts } from   '../Themes'
import styles from './Styles/SignUpV2ScreenStyle'
import { validateSignUp } from '../Components/ValidateComponent';
import FooterButton from '../Components/FooterButton';
import BaseScreen from './BaseScreen';
import I18n from "i18n-js"


// https://stackoverflow.com/questions/32748718/react-native-how-to-select-the-next-textinput-after-pressing-the-next-keyboar
// TextInputManager
//
// Provides helper functions for managing the focus state of text
// inputs. This is a hack! You are supposed to be able to call
// "focus()" directly on TextInput nodes, but that doesn't seem
// to be working as of ReactNative 0.36
//
import { findNodeHandle } from 'react-native'
//not avail on web import TextInputState from 'react-native/lib/TextInputState'


export function focusTextInput(node) {
  try {
    // TextInputState.focusTextInput(findNodeHandle(node))
    // not avail on web TextInputState.focusTextInput(findNodeHandle(node))
  } catch(e) {
    console.log("Couldn't focus text input: ", e.message)
  }
}



let { width: screenWidth, height: screenHeight } = Dimensions.get('window')

class SignUpV2Screen extends Component {

  static navigationOptions = {
    header: null,

  }
  constructor(props) {
    super(props);
    this.state = {
      bio: null,
      email: null,
      firstName: null,
      lastName: null,
      password: null,
      passwordAgain: null,
      phone: null,
      photo: null,
      termsOfUseAccepted: false, // TODO UI
      username: null,
      errors: {
        username: '',
        password: '',
        email: '',
        phone: '',
        accept: false,
      },
      creating: false,
      rerender: null,
      screenOpacity: new Animated.Value(0),
    }
    this.values = {
      username: '',
      password: '',
      email: '',
      phone: '',
      accept: false,
		}
    this.belowKeyboardHeight = 0 // fix?
    this.keyboardHeight = new Animated.Value(0)
    this.whiteLine = new Animated.Value(0)

    // https://stackoverflow.com/questions/45082914/reactnative-textinput-focus
    this.focusNextField = this.focusNextField.bind(this)
    this.onAcceptToggle = this.onAcceptToggle.bind(this)
    this.onRegister = this.onRegister.bind(this)
    this.filter = this.filter.bind(this)
    this.valid = this.valid.bind(this)
    this.onBackPress = this.onBackPress.bind(this)
    this.inputs = []
  }

  focusNextField(id) {
		if (this.inputs[id])
			this.inputs[id].focus() // good time for a validate...
  }

  componentDidMount() {
    //this.navigationBar.setLeftNavBarButtons([{ onPress: this.onBackPress, type: 'back' } ])
    console.log(`SignUpV2 componentDidMount`)
    this.focusListener = this.props.navigation.addListener('didFocus', () => this.inputs['username'].focus())
    this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
    this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
  }

  componentWillUnmount( ) {
    this.focusListener.remove();
    this.keyboardWillShowListener.remove( )
    this.keyboardWillHideListener.remove( )
  }

  keyboardWillShow = e => {
    console.tron.display({ name: `SignUpV2`, preview: `keyboardWillShow`, value: { endCoordinates: e.endCoordinates, screenWidth: screenWidth, screenHeight: screenHeight } })
    // Animated.timing( this.keyboardHeight, { toValue : e.endCoordinates.height, duration : 333 }).start( )
    Animated.timing( this.keyboardHeight, { toValue : e.endCoordinates.height + this.belowKeyboardHeight, duration : 333 }).start( )
    Animated.timing( this.whiteLine, { toValue : 25, duration : 333 }).start( )
    // Animated.timing( this.state.screenOpacity, { toValue : 1, delay : 333, duration: 444, easing: Easing.linear }).start( )
    Animated.timing( this.state.screenOpacity, { toValue : 1, delay : 233, duration: 333, easing: Easing.linear }).start( )
  }

  keyboardWillHide = e => {
    Animated.timing( this.keyboardHeight, { toValue : 0, duration : 333 }).start( )
    Animated.timing( this.whiteLine, { toValue : 0, duration : 333 }).start( )
    // Animated.timing( this.state.screenOpacity, { toValue : 0, delay: 0, duration : 100, easing: Easing.linear }).start( )
  }

  onBackPress = () => {
    // this.props.navigation.goBack()
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'auth' })]
    }))
  }

  isFilled = () =>
    !!(
      this.state.username &&
      this.state.email &&
      this.state.password &&
      this.state.passwordAgain &&
      this.state.termsOfUseAccepted
    )

  onTermAndConditionPress = () => {
    this.props.navigation.navigate('WebViewScreen', { title: 'Terms and Conditions', url: TERMURL });
  }

  keyboardAccessory = () => (
    <FooterButton
      disabled={!this.isFilled() || this.props.submitting}
      onPress={this.props.handleSubmit(this.signUp)}
      style={styles.footerButton}
      title={`Sign Me Up`}
    />
  )

  filter(value, fieldName) {
    // TODO - this should be more of a filter - to prevent wrong characters from being entered, validate should happen when switching fields (focus) or submit.
    // get raw field value with _lastNativeText
    // console.tron.log(`validate value ${value}, kind ${kind}, inputs: ${this.inputs.length}`)
    let usernameError = ''
    let passwordError = ''
    let emailError    = ''
    let phoneError    = ''
    let acceptError   = false
    let newValue      = null
    switch (fieldName) {
      case 'username':
        if (value.length > 20)
          usernameError = 'Must be less than 20 characters'
        if (value.length > 21)
          newValue = value.substr(0, 21)
        if (value.length > 0 && value.substr(-1) == ' ') // no spaces
          newValue = value.substr(0, value.length - 1)
        if (newValue)
          this.inputs[fieldName].setNativeProps({text: newValue})
        this.values.username = newValue ? newValue : value
        break
      case 'password':
        this.values.password = newValue ? newValue : value
        break
      case 'email':
        this.values.email = newValue ? newValue : value
        break
      case 'phone':
        if (value.length > 16)
          phoneError = "Must be 16 digits or less"
        if (value.length > 17)
          newValue = value.substr(0, 17)
        if (newValue)
          this.inputs[fieldName].setNativeProps({text: newValue})
        this.values.phone = newValue ? newValue : value
        break;
      case 'accept':
    }
    const errors = this.state.errors
    if (usernameError != errors.username || passwordError != errors.password || emailError != errors.email || phoneError != errors.phone) {
      console.tron.log(`We have validation errors`)
      this.setState(Object.assign({}, this.state, {errors: {
        username: usernameError,
        password: passwordError,
        email:    emailError,
        phone:    phoneError,
        accept:   acceptError,
      }}))
    }
  }

  valid() {
    console.tron.log(`valid`)
    let usernameError = ''
    let passwordError = ''
    let emailError    = ''
    let phoneError    = ''
    let acceptError   = false
    const values = this.values

    // const username = this.inputs['username']._lastNativeText // does not work
    console.tron.display({ name: `SignUpV2`, preview: `valid`, value: { values: values } })
    if (values.username.length == 0)
      usernameError = I18n.t('deliverAddress.required')
/*
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d,.;:]).+$/.test(values.password))
      passwordError = 'Must use at least 1 capital, 1 lower case, and 1 number'
    if (values.password.length < 8)
      passwordError = 'Must be 8 at least characters'
*/
    if (values.password.length == 0) // complex checks followed by easiest checks, for each field
      passwordError = I18n.t('deliverAddress.required')
    // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))
    //  emailError = 'Invalid email address'
    if (values.email.length == 0)
      emailError = I18n.t('deliverAddress.required')
    // if (values.phone.length == 0)
    //  phoneError = 'Required'
    // if (!values.accept)
    //  acceptError = true

		if (this.props.isAddProfile) {
			emailError = ''
			phoneError = ''
		}

		this.setState(Object.assign({}, this.state, {errors: {
      username: usernameError,
      password: passwordError,
      email:    emailError,
      phone:    phoneError,
      accept:   acceptError,
    }}))
    return (!usernameError && !passwordError && !emailError && !phoneError && !acceptError)
  }

  onAcceptToggle() {
    this.values.accept = !this.values.accept
    this.setState({rerender: true})
    this.filter(this.values.accept, 'accept')
  }

  onRegister() {
    if (!this.state.creating && this.valid()) {
      console.tron.log(`valid`)
      this.setState({creating: true})
      // TODO - call up the API
			const values = this.values
			const email = this.props.isAddProfile ? this.props.auth.user.Email : values.email
			const phone = this.props.isAddProfile ? this.props.auth.user.Phone : values.phone
      this.props.signup({
        Username: values.username,
        LastName: '',
        FirstName: '',
        Phone: phone,
        Email: email,
        Password: values.password,
        TermsOfUseAccepted: values.accept,
        Login: true,
        Bio: ''
      })
    }
    else {
      console.tron.log(`onRegister - did not validate, creating: ${this.state.creating}`)
    }
  }

  resetRoute(routeName, params = {}) {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: routeName, params: params })]
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.auth.modified != this.props.auth.modified) {
      console.tron.display({ name: `SignUpV2`, preview: `componentDidUpdate modified`, value: { auth: this.props.auth } })
      const auth = this.props.auth
      if (auth.success) {
        console.tron.display({ name: `SignUpV2`, preview: `componentDidUpdate did signup`, value: { auth: auth } })
        // this.resetRoute('profileSetup', {isScroll : true}) // get taken to Home
        // this.props.navigation.navigate('profileSetup', {isScroll : true}); // get taken to Home, even with a nav stack size of 1
        setTimeout(() => {

          this.props.navigation.dispatch(NavigationActions.reset({
              index: 0,
              key: null,
              actions: [NavigationActions.navigate({ routeName: 'profileSetup', params: {isScroll : true} })]
          }))

          // this.props.navigation.navigate('profileSetup', {isScroll : true}); // Home wall briefly shows up, and then Profile, finish up on Home
        }, 1)
      } // success
      else {
        this.setState({creating: false, errors: auth.error})
      }
    }
  }
  focusField(fieldname) {
    console.log('in focusField ' + fieldname)
    if (this.inputs && this.inputs[fieldname]) this.inputs[fieldname].focus()
  }
  render() {
    console.log("signup render")
    const passwordLabelWidth = isIPhoneX() ? /*85*/95 : 75
    const keyboardHgt     = 0 + this.keyboardHeight.__getValue()
    const statusBarHeight = isIPhoneX() ? 30 : 20
    const fontSize        = isIPhoneX() ? /*17*/16 : 14
    const fontSizeInput    = fontSize - 2
    const scrollHeight    = screenHeight - statusBarHeight - (isNaN(this.keyboardHeight) ? 0 : this.keyboardHeight) //  - this.whiteLine
    const headerStyle     = {flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 10, paddingLeft: 10, paddingRight: 10}
    const titleStyle      = {width: '60%', textAlign: 'center', fontWeight: 'bold'}
    const rowStyle        = {minHeight: 31.5, paddingLeft: 10, paddingRight: 10, fontSize, marginTop: 15}
    const separatorStyle  = {height: 1, width: screenWidth, borderBottomWidth: 1, borderColor: '#cccccc'}
    const fieldStyle      = {flexDirection: 'row', justifyContent: 'space-between'}
    const labelStyle      = {flex: 0.3, fontSize, fontFamily: Fonts.style.font.semiBold}
    const labelNoFxStyle  = {fontSize, fontFamily: Fonts.style.font.semiBold}
    const inputStyle      = {flex: 0.7, backgroundColor: 'white', textAlign: 'right', paddingRight: 5, fontSize}
    const inputNoFxStyle  = {backgroundColor: 'white', textAlign: 'right', paddingRight: 5, fontSizeInput}
    const errorStyle      = {color: '#ff3d3d', fontSize: 12, height: 15, textAlign: 'right', paddingRight: 5}
    const continueBtnHeight = isIPhoneX() ? 50 : 40
    const continueFontSize = isIPhoneX() ? 21 : 17
    const headerFontSize   = isIPhoneX() ? 21 : 17
    const titleBottom      = isIPhoneX() ? 40 : 0
    const wideButtonStyle = {width: '100%', height: continueBtnHeight, backgroundColor: 'black', justifyContent: 'center', alignItems: 'center', flex: 1}
    const buttonTextStyle = {color: 'white', fontSize: continueFontSize, fontFamily:Fonts.style.font.extraBold}
    const continueLabel   = this.state.creating ? I18n.t('signUp.checking') : I18n.t('signUp.continue')
    const acceptHeight    = (fontSize + 5) * 2
    const acceptRowStyle  = {minHeight: acceptHeight + 10}
    const acceptButtonStyle = {flex: 1, minHeight: acceptHeight + 10, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}
    // const acceptStyle     = {backgroundColor: 'blue', flex: 1, flexDirection: 'row', justifyContent: 'center', height: acceptHeight}
    const acceptControlStyle = {paddingRight: 15, height: acceptHeight, lineHeight: acceptHeight}
    const acceptControl   = this.values.accept ? `⚫` : `⚪` // `✅` : `⬜`
    const acceptLabelStyle = {fontSize, lineHeight: acceptHeight / 2, fontFamily: Fonts.style.font.semiBold, color: ((this.state.errors && this.state.errors.accept) ? 'red' : 'black')}
    const continueRowStyle = {}
    const inputProps      = {
      style: inputStyle,
      keyboardType: 'default',
      autoCapitalize: 'false',
      autoCorrect: false,
      blurOnSubmit: true,
      returnKeyType: 'next'
    }
    const phoneInputProps = {
      style: [inputStyle, {flex: 0.5}],
      keyboardType: 'default',
      autoCapitalize: 'false',
      autoCorrect: false,
      blurOnSubmit: true,
      returnKeyType: 'next'
    }
    const passwordInputProps = {
      style: [inputNoFxStyle, {width: screenWidth - passwordLabelWidth - 25}],
      keyboardType: 'default',
      autoCapitalize: 'false',
      autoCorrect: false,
      blurOnSubmit: true,
      returnKeyType: 'next'
		}
		const isAddProfile = this.props.isAddProfile
		// const defaultEmail = !isAddProfile ? '' : this.props.auth.user.Email
		// const defaultPhone = !isAddProfile ? '' : this.props.auth.user.Phone
    console.tron.display({ name: `SignUpV2`, preview: `render`, value: { fontSize: fontSize, acceptHeight: acceptHeight, acceptButtonStyle: acceptButtonStyle } })
//               <View style={separatorStyle}/>
// this.state.screenOpacity
    if (!this.state.errors) this.state.errors = {} // catch net fail case, may not be server errors reported (or following code red screens)
    console.log('signup render before return')
    return (
      <BaseScreen style={{backgroundColor: 'white', width: '100%', height: '100%'}}>        
        <TouchableWithoutFeedback style={{flex: 1, height: '100%', width: '100%', backgroundColor: 'yellow'}}>
          <View keyboardShouldPersistTaps='always' style={{opacity: this.state.screenOpacity, position: 'absolute', width: screenWidth, top: statusBarHeight, bottom: this.keyboardHeight}}>
            <View keyboardShouldPersistTaps='always' style={{}} contentContainerStyle={{flex: 1, flexDirection: 'column', justifyContent: 'space-between', height: scrollHeight}}>
              <View style={headerStyle}>
                <TouchableOpacity onPress={() => {this.props.isAddProfile ? this.props.cancelAddProfile() : this.onBackPress()}} style={{width: '20%'}}>
                  <Text>Back</Text>
                </TouchableOpacity>
                <Text style={{width: '60%', textAlign: 'center', fontSize: headerFontSize, fontFamily:Fonts.style.font.extraBold, marginBottom: titleBottom }}>{I18n.t('login.signUp')}</Text>
              </View>
              <TouchableOpacity style={rowStyle} onPress={this.focusField.bind(this, 'username')}>
                <View style={fieldStyle}>
                  <Text maxFontSizeMultiplier={1} numberOfLines={1} adjustsFontSizeToFit style={labelStyle}>{I18n.t('login.username')}</Text>
                  <TextInput {...inputProps} placeholder={I18n.t('signUp.minCharacter')} ref={ref => {this.inputs['username'] = ref}} onChangeText={(val) => this.filter(val, 'username')} onSubmitEditing={() => {this.focusNextField('password')}} autoFocus={true}/>
                </View>
                <Text style={errorStyle}>{this.state.errors.username}</Text>
              </TouchableOpacity>
              <View style={separatorStyle}/>
              <TouchableOpacity style={rowStyle} onPress={this.focusField.bind(this, 'password')}>
                <View style={fieldStyle}>
                  <Text maxFontSizeMultiplier={1} numberOfLines={1} adjustsFontSizeToFit style={[labelNoFxStyle, {width: passwordLabelWidth}]}>{I18n.t('login.password')}</Text>
                  <TextInput {...passwordInputProps} placeholder={I18n.t('signUp.rulePass')} ref={ref => {this.inputs['password'] = ref}} onChangeText={(val) => this.filter(val, 'password')} onSubmitEditing={() => {this.focusNextField('email')}} secureTextEntry={true}/>
                </View>
                <Text style={errorStyle}>{this.state.errors.password}</Text>
              </TouchableOpacity>
              <View style={separatorStyle}/>
              {!isAddProfile && <TouchableOpacity style={rowStyle} onPress={this.focusField.bind(this, 'email')}>
                <View style={fieldStyle}>
                  <Text style={labelStyle}>Email</Text>
                  <TextInput {...inputProps} placeholder={`name@domain.com`} ref={ref => {this.inputs['email'] = ref}} onChangeText={(val) => this.filter(val, 'email')} onSubmitEditing={() => {this.focusNextField('phone')}} keyboardType='email-address'/>
                </View>
                <Text style={errorStyle}>{this.state.errors.email}</Text>
              </TouchableOpacity>}
              {!isAddProfile && <View style={separatorStyle}/>}
              {!isAddProfile && <TouchableOpacity style={rowStyle} onPress={this.focusField.bind(this, 'phone')}>
                <View style={fieldStyle}>
                  <Text numberOfLines={1} adjustsFontSizeToFit style={[labelStyle, {flex: 0.5}]}>{I18n.t('signUp.phoneNumber')}</Text>
                  <TextInput {...phoneInputProps} placeholder={I18n.t('signUp.optional')} ref={ref => {this.inputs['phone'] = ref}} onChangeText={(val) => this.filter(val, 'phone')} onSubmitEditing={() => {this.focusNextField('username')}} keyboardType='phone-pad'/>
                </View>
                <Text style={errorStyle}>{this.state.errors.phone}</Text>
              </TouchableOpacity>}
							{isAddProfile && <View style={{width: '100%', height: 100, justifyContent: 'center', alignContent: 'center'}}>
									<Text style={{color: 'gray', textAlign: 'center', marginLeft: 25, marginRight: 25, marginBottom: 10}}>{I18n.t('signUp.addProfileNote1')}</Text>
									<Text style={{color: 'gray', textAlign: 'center', marginLeft: 25, marginRight: 25}}>{I18n.t('signUp.addProfileNote2')}</Text>
								</View>}
              <View style={separatorStyle}/>
              <View style={acceptRowStyle}>
                <TouchableOpacity activeOpacity={0.5} onPress={this.onAcceptToggle} style={acceptButtonStyle}>
                  <Text style={acceptControlStyle}>{acceptControl}</Text>
                  <View>
                    <Text style={acceptLabelStyle}>{I18n.t('signUp.terms')}</Text>
                    <Text style={acceptLabelStyle} onPress={this.onTermAndConditionPress}>the <Text style={{textDecorationLine: 'underline'}}>{I18n.t('signUp.terms2')}</Text></Text>
                  </View>
                </TouchableOpacity>
              </View>
              <View style={continueRowStyle}>
                <View style={fieldStyle}>
                  <TouchableOpacity activeOpacity={0.5} onPress={this.onRegister} style={wideButtonStyle}>
                    <Text style={buttonTextStyle}>{continueLabel}</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </TouchableWithoutFeedback>
      </BaseScreen>
    )
    //                   <View style={acceptStyle}>
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
		isAddProfile: state.auth.authBackup && state.auth.authBackup.user,
  }
}

const mapDispatchToProps = (dispatch) => ({ // crashing at 461 next line w/ no network
  signup: (params) => dispatch(AuthActions.signupRequest(params)),
	cancelAddProfile: () => dispatch(AuthActions.cancelAddProfileRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpV2Screen)
